export default {
  container: {
    paddingTop: 10,
    paddingLeft: 12,
    paddingRight: 12,
  },

  imageWrapper: {
    margin: [0, -12, 20],
  },

  image: {
    backgroundColor: '#c7c7c7',
    width: '100%',
    display: 'block',
    height: 194,
    marginBottom: 12,
    objectFit: 'cover',
  },
  title: {
    fontFamily: 'Giorgio Sans',
    fontWeight: 'bold',
    fontSize: 20,
    lineHeight: 1.1,
    textTransform: 'uppercase',
    letterSpacing: 0.03,
    marginTop: -10,
    wordWrap: 'break-word',
  },
};
